type WantedReflectionCellOpacityInput = {
  readonly isBannedShiftViolation: boolean;
  readonly isCellValidationError: boolean;
  readonly isWantedAdjustmentBoard: boolean;
  readonly isWantedMatch: boolean;
  readonly isWantedMismatch: boolean;
  readonly isWantedReflectionVisible: boolean;
  readonly isWithinInboundLock: boolean;
};

export function shouldDimWantedReflectionCell({
  isBannedShiftViolation,
  isCellValidationError,
  isWantedAdjustmentBoard,
  isWantedMatch,
  isWantedMismatch,
  isWantedReflectionVisible,
  isWithinInboundLock,
}: WantedReflectionCellOpacityInput): boolean {
  if (
    isWantedAdjustmentBoard ||
    !isWantedReflectionVisible ||
    isWithinInboundLock
  ) {
    return false;
  }

  return (
    !isWantedMatch &&
    !isWantedMismatch &&
    !isBannedShiftViolation &&
    !isCellValidationError
  );
}
